// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
